import { render, staticRenderFns } from "./InfoRegister.vue?vue&type=template&id=649694f5&"
import script from "./InfoRegister.vue?vue&type=script&lang=js&"
export * from "./InfoRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports